import { render, staticRenderFns } from "./PublicationCard.vue?vue&type=template&id=47275645&scoped=true&"
import script from "./PublicationCard.vue?vue&type=script&lang=js&"
export * from "./PublicationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47275645",
  null
  
)

export default component.exports